import React from 'react';

interface ITimer {
    isExpired: boolean;
    days: number
    minutes: number;
    seconds: number;
    hours: number;
}

const GeneralDays = ({ isExpired, days, minutes, seconds, hours }: ITimer) => {
    return (
        <>
            {
                isExpired || (minutes === 0 && seconds === 0 && hours === 0 && days === 0) ?
                <></>
                :
                <>
                    {days > 0 &&
                        <>
                            {days.toString().length === 1 ? days.toString() : days.toString()} {days === 1 ? 'Day' : 'Days'},&nbsp;
                        </>
                    }
                    {hours.toString().length === 1 ? "0" + hours.toString() : hours.toString()}
                    :{minutes.toString().length === 1 ? "0" + minutes.toString() : minutes.toString()}
                    :{seconds.toString().length === 1 ? "0" + seconds.toString() : seconds.toString()}
                </>
            }
        </>
    )
};

export default GeneralDays;